import styled from "styled-components";
export const StyledHeader = styled.div`
  .header-container {
    width: 100%;
    height: max-content;
    padding: 32px 0;
    background-color: #f1f4f7;
    display: flex;
    justify-content: center;
    .content {
      width: max-content;
      display: flex;
      align-items: center;
      flex-flow: row nowrap;
      gap: 48px;

      .title-box {
        width: max-content;
        padding-top: 20px;
        .header {
          line-height: 32px;
          font-weight: 700;
          font-size: 22px;
          padding-bottom: 4px;
        }
        .center {
          line-height: 28px;
          font-weight: 300;
          font-size: 22px;
        }
        .selected-date-range {
          line-height: 24px;
          font-weight: 300;
          font-size: 15px;
        }
        .selected-condition {
          margin-top: 6px;
          box-sizing: border-box;
          color: #fff;
          font-weight: 300;
          font-size: 14px;
          padding: 8px 24px;
          background-color: #4679cc;
          box-shadow: 0px 2px 1px 0px rgba(255, 255, 255, 0.2) inset,
            0px 1px 2px 0px rgba(0, 0, 0, 0.2);
          outline: none;
          border-radius: 4px;
          border: 1px solid #4679cc;
          cursor: pointer;
        }
      }

      .dashboard {
        display: flex;
        flex-flow: column nowrap;
        gap: 4px;
        .title {
          display: flex;
          gap: 8px;
          & > p {
            color: #494949;
            font-weight: 700;
            font-size: 22px;
          }
        }

        .card-wrap {
          display: flex;
          gap: 16px;
          .card {
            display: flex;
            flex-flow: column nowrap;
            gap: 6px;
            align-items: center;
            padding: 22px 8px;
            width: 200px;
            border-radius: 4px;
            .label {
              font-weight: 300;
              font-size: 12px;
            }
            .value {
              font-size: 40px;
              font-weight: 700;
              line-height: 50px;
            }

            &.total {
              background-color: #fd52a3;
              color: #fff;
            }
            &.detected {
              background-color: #ffd274;
              color: #232323;
            }
            &.received {
              background-color: #51adf6;
              color: #fff;
            }
            &.operation {
              background-color: #5a87da;
              color: #fff;
            }
            &.linkage {
              background-color: #1dc9b7;
              color: #fff;
            }
          }
        }
      }
    }
  }
`;
